'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { debounce } from 'underscore';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import ReactDOM from 'react-dom';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import InitialFilterParams from '../constants/InitialFilterParams';
import { requestStatusPropType } from '../constants/propTypes/requestStatus';
import SearchBar from '../components/SearchBar';
import { getSidebarFiltersFromOptionValue } from '../utils/searchBarUtils';
import * as GoodsActions from '../actions/GoodsActions';
import { getProviderNames, getProvidersRequestStatus } from '../selectors/providers';
var SearchBarContainer = createReactClass({
  displayName: "SearchBarContainer",
  propTypes: {
    allProviders: PropTypes.array.isRequired,
    appliedSearchTerm: PropTypes.string,
    autocomplete: PropTypes.instanceOf(Immutable.Map).isRequired,
    categoryFilter: PropTypes.string.isRequired,
    fetchForAutocomplete: PropTypes.func.isRequired,
    fetchMatchingSearchResults: PropTypes.func.isRequired,
    fetchProviders: PropTypes.func.isRequired,
    goodFilters: PropTypes.instanceOf(Immutable.Map).isRequired,
    goToGoodSearchOption: PropTypes.func.isRequired,
    hideAutocompleteMenu: PropTypes.func.isRequired,
    providersRequestStatus: requestStatusPropType.isRequired,
    screen: PropTypes.string.isRequired
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.debouncedFetchForAutocomplete = debounce(this.props.fetchForAutocomplete, 100);
  },
  componentDidMount: function componentDidMount() {
    window.addEventListener('click', this.handleWindowClick);
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);
  },
  handleWindowClick: function handleWindowClick(evt) {
    var searchBarDOMNode = ReactDOM.findDOMNode(this.searchBar);

    if (searchBarDOMNode && !searchBarDOMNode.contains(evt.target)) {
      this.props.hideAutocompleteMenu();
    }
  },
  handleSidebarFilterSelection: function handleSidebarFilterSelection(value) {
    var _Object$assign;

    this.props.fetchMatchingSearchResults(Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, GoodFiltersAndPage.SEARCH_TERM, InitialFilterParams.get(GoodFiltersAndPage.SEARCH_TERM)), _defineProperty(_Object$assign, GoodFiltersAndPage.PAGE, InitialFilterParams.get(GoodFiltersAndPage.PAGE)), _Object$assign), getSidebarFiltersFromOptionValue(value)), this.props.screen);
  },
  handleFilterByNameSelection: function handleFilterByNameSelection(searchTerm) {
    var _this$props$fetchMatc;

    this.props.fetchMatchingSearchResults((_this$props$fetchMatc = {}, _defineProperty(_this$props$fetchMatc, GoodFiltersAndPage.PAGE, InitialFilterParams.get(GoodFiltersAndPage.PAGE)), _defineProperty(_this$props$fetchMatc, GoodFiltersAndPage.SEARCH_TERM, searchTerm), _this$props$fetchMatc), this.props.screen);
  },
  handleGoodSelection: function handleGoodSelection(goodUrlToken) {
    this.props.goToGoodSearchOption(goodUrlToken, this.props.screen);
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        allProviders = _this$props.allProviders,
        appliedSearchTerm = _this$props.appliedSearchTerm,
        autocomplete = _this$props.autocomplete,
        categoryFilter = _this$props.categoryFilter,
        fetchProviders = _this$props.fetchProviders,
        goodFilters = _this$props.goodFilters,
        providersRequestStatus = _this$props.providersRequestStatus;
    return React.createElement(SearchBar, {
      ref: function ref(_ref) {
        _this.searchBar = _ref;
      },
      allProviders: allProviders,
      appliedSearchTerm: appliedSearchTerm || '',
      autocomplete: autocomplete,
      categoryFilter: categoryFilter,
      debouncedFetchForAutocomplete: this.debouncedFetchForAutocomplete,
      fetchProviders: fetchProviders,
      goodFilters: goodFilters,
      onFilterByNameSelection: this.handleFilterByNameSelection,
      onGoodSelection: this.handleGoodSelection,
      onSidebarFilterSelection: this.handleSidebarFilterSelection,
      providersRequestStatus: providersRequestStatus
    });
  }
});

function mapStateToProps(state) {
  return {
    allProviders: getProviderNames(state),
    autocomplete: state.autocomplete,
    goodFilters: state.directoryData.get('goodFiltersAndPage'),
    providersRequestStatus: getProvidersRequestStatus(state)
  };
}

var mapDispatchToProps = {
  fetchForAutocomplete: GoodsActions.fetchForAutocomplete,
  fetchMatchingSearchResults: GoodsActions.fetchMatchingSearchResults,
  fetchProviders: GoodsActions.getProviderNames,
  goToGoodSearchOption: GoodsActions.goToGoodSearchOption,
  hideAutocompleteMenu: GoodsActions.hideAutocompleteMenu
};
export default connect(mapStateToProps, mapDispatchToProps)(SearchBarContainer);